/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      background: '#F5F5F5',
      paddingTop: '40px',
      textAlign: 'center',
    },
    gridContainer: {
      width: '100%',
    },
    gridParent: {
      overflow: 'hidden',
      padding: '0px 24px',
    },
    optionContainer: {
      backgroundColor: '#00000000',
      color: '#999',
      cursor: 'pointer',
      fontWight: '600',
      height: '100%',
      padding: '27px 0px 15px',
      textAlign: 'center',
      transition: 'all 0.2s',
    },
    optionContainerActive: {
      backgroundColor: '#172B4D',
      borderRadius: '10px 10px 0px 0px',
      borderTop: `4px solid ${theme.palette.primary.main}`,
      color: '#FFF',
      cursor: 'pointer',
      fontWeight: '600',
      height: '100%',
      padding: '27px 0px 15px',
      textAlign: 'center',
      transition: 'all 0.2s',
    },
    title: {
      color: '#172B4D',
      fontSize: '24px',
      fontWeight: '700',
      lineHeight: '36px',
      marginBottom: '34px !important',
    },
    [theme.breakpoints.up('md')]: {
      container: {
        paddingTop: '58px',
      },
      gridContainer: {
        margin: 'auto',
        width: '560px',
      },
      title: {
        fontSize: '34px',
        fontWeight: '500',
      },
    },
  };
});

export default ({ onPackageOptionChange, packageOption }) => {
  const classes = useStyles();

  const handlePackageOptionChange = (option) => {
    if (!onPackageOptionChange || typeof onPackageOptionChange !== 'function') return;
    onPackageOptionChange(option);
  };

  const videoClasses = packageOption === 'video' ? classes.optionContainerActive : classes.optionContainer;
  const storageClasses = packageOption === 'storage' ? classes.optionContainerActive : classes.optionContainer;

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h1">
        Select a package
      </Typography>

      <Container className={classes.gridParent}>
        <Grid container justify="center">
          <Grid item style={{ width: '100%' }}>
            <div className={classes.gridContainer} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
